import { Link } from "react-router-dom";
import { motion } from "framer-motion";

// ✅ assets
import mentorImg from "./assets/characters/mentor.png";
import swirl from "./assets/ui/ornamental-swirl.svg";
//import paperTexture from "./assets/ui/paper-texture.png";
import { useEffect } from "react";
import StorySection from "./components/storySection";
import { FaFire, FaBullseye, FaTrophy, FaBolt } from "react-icons/fa";
//import AutoCinematicScroll from "./components/AutoCinematicScroll";
import LearningAnalytics from "./components/LearningAnalytics";



const tests = [
  {
    _id: "69881c424cf5a2ddb6f093ce",   // Multiple Choice Quiz
    title: "Multiple Choice Quiz",
    desc: "Test your knowledge with carefully curated questions across topics.",
    qs: 30,
    time: "Practice",
    level: "Public",
    color: "bg-blue-600"
  },
  {
    _id: "698823b34cf5a2ddb6f093ef",   // Coding Challenge
    title: "Coding Challenge",
    desc: "Sharpen your programming skills with real-world coding problems.",
    qs: 25,
    time: "Practice",
    level: "Public",
    color: "bg-purple-600"
  },
  {
    _id: "create",
    title: "Custom Test",
    desc: "Create your own personalized test with custom topics & rules.",
    qs: "Custom",
    time: "Flexible",
    level: "Variable",
    color: "bg-orange-600"
  }
];







function FooterColumn({ title, links }) {
  return (
    <div>
      <h4 className="text-lg font-semibold mb-4 text-[#3A2A1A]">
        {title}
      </h4>
      <ul className="space-y-2 text-sm text-[#5C4632]">
        {links.map((link) => (
          <li
            key={link}
            className="cursor-pointer hover:text-[#7A4A28] transition"
          >
            {link}
          </li>
        ))}
      </ul>
    </div>
  );
}


function MetricCard({ value, label, sub, color, delay, icon }) {
  const colors = {
    orange: "metric-orange text-orange-500",
    blue: "metric-blue text-blue-500",
    yellow: "metric-yellow text-yellow-500",
    purple: "metric-purple text-purple-500",
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.0, delay }}
      whileHover={{ scale: 1.04 }}   // 👈 box bada hoga
      className={`metric-card ${colors[color]}`}
    >
      {/* ICON */}
      {icon && (
  <div className={`metric-icon ${color}`}>
    {icon}
  </div>
)}


      <div className="metric-inner">
        <div className="text-3xl font-bold mb-1">{value}</div>
        <div className="text-sm text-[#3A2A1A]">{label}</div>
        <div className="text-xs text-[#7A4A28]">{sub}</div>
      </div>
    </motion.div>
  );
}

function LearningItem({ title, desc, percent = 0, color = "blue", completed, locked }) {
  const barColor =
    color === "green"
      ? "bg-green-500"
      : "bg-blue-500";

  return (
    <div
      className={`relative border rounded-xl p-6
        ${completed ? "border-green-400/60" : locked ? "border-gray-400/40 opacity-50" : "border-blue-400/60"}
      `}
    >
      {/* HEADER */}
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-3">
          <span className="text-xl">
            {completed ? "✅" : locked ? "🔒" : "▶"}
          </span>
          <h3 className="text-lg font-semibold text-[#3A2A1A]">
            {title}
          </h3>
        </div>

        {!locked && (
          <span
            className={`text-sm font-semibold px-3 py-1 rounded-full
              ${completed ? "bg-green-200 text-green-800" : "bg-blue-200 text-blue-800"}
            `}
          >
            {completed ? "100%" : `${percent}%`}
          </span>
        )}
      </div>

      {/* DESC */}
      <p className="text-sm text-[#5C4632] mb-4">
        {desc}
      </p>

      {/* PROGRESS BAR */}
      {!locked && (
        <div className="h-2 bg-gray-300 rounded-full overflow-hidden">
          <motion.div
            initial={{ width: 0 }}
            whileInView={{ width: `${percent}%` }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
            className={`h-full ${barColor}`}
          />
        </div>
      )}
    </div>
  );
}

export default function HomePage() {
  useEffect(() => {
    // ===== BACKGROUND PAPER PARTICLES =====

const bgCanvas = document.getElementById("bg-particle-canvas");
if (!bgCanvas) return;
const bgCtx = bgCanvas.getContext("2d");

const resizeBg = () => {
  bgCanvas.width = window.innerWidth;
  bgCanvas.height = window.innerHeight;
};

resizeBg();
window.addEventListener("resize", resizeBg);

const bgParticles = [];
const BG_COUNT = 25;   // small amount

class BgParticle {
  constructor() {
    this.x = Math.random() * bgCanvas.width;
    this.y = Math.random() * bgCanvas.height;
    this.vx = (Math.random() - 0.5) * 0.25;
    this.vy = (Math.random() - 0.5) * 0.25;
    this.r = 1;
  }

  move() {
    this.x += this.vx;
    this.y += this.vy;

    if (this.x < 0 || this.x > bgCanvas.width) this.vx *= -1;
    if (this.y < 0 || this.y > bgCanvas.height) this.vy *= -1;
  }

  draw() {
    bgCtx.beginPath();
    bgCtx.arc(this.x, this.y, this.r, 0, Math.PI * 2);
    bgCtx.fillStyle = "rgba(58,42,26,0.75)";
 // theme brown
    bgCtx.fill();
  }
}

for (let i = 0; i < BG_COUNT; i++) {
  bgParticles.push(new BgParticle());
}

const bgConnect = () => {
  for (let i = 0; i < bgParticles.length; i++) {
    for (let j = i + 1; j < bgParticles.length; j++) {
      const dx = bgParticles[i].x - bgParticles[j].x;
      const dy = bgParticles[i].y - bgParticles[j].y;
      const dist = Math.sqrt(dx * dx + dy * dy);

      if (dist < 70) {
        bgCtx.strokeStyle = `rgba(122,74,40,${0.3 - dist / 200})`;
        bgCtx.lineWidth = 0.5;
        bgCtx.beginPath();
        bgCtx.moveTo(bgParticles[i].x, bgParticles[i].y);
        bgCtx.lineTo(bgParticles[j].x, bgParticles[j].y);
        bgCtx.stroke();
      }
    }
  }
};

const bgAnimate = () => {
  bgCtx.clearRect(0, 0, bgCanvas.width, bgCanvas.height);

  bgParticles.forEach(p => {
    p.move();
    p.draw();
  });

  bgConnect();
  requestAnimationFrame(bgAnimate);
};

bgAnimate();

  const canvas = document.getElementById("particle-canvas");
  const ctx = canvas.getContext("2d");

  const resize = () => {
    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;
  };

  resize();
  window.addEventListener("resize", resize);

  const particles = [];
  const COUNT = 70;

  class Particle {
    constructor() {
      this.x = Math.random() * canvas.width;
      this.y = Math.random() * canvas.height;
      this.vx = (Math.random() - 0.5) * 0.6;
      this.vy = (Math.random() - 0.5) * 0.6;
      this.r = 1.5;
    }

    move() {
      this.x += this.vx;
      this.y += this.vy;

      if (this.x < 0 || this.x > canvas.width) this.vx *= -1;
      if (this.y < 0 || this.y > canvas.height) this.vy *= -1;
    }

    draw() {
      ctx.beginPath();
      ctx.arc(this.x, this.y, this.r, 0, Math.PI * 2);
      ctx.fillStyle = "rgba(90,50,15,0.6)";
      ctx.fill();
    }
  }

  for (let i = 0; i < COUNT; i++) {
    particles.push(new Particle());
  }

  const connect = () => {
    for (let i = 0; i < particles.length; i++) {
      for (let j = i + 1; j < particles.length; j++) {
        const dx = particles[i].x - particles[j].x;
        const dy = particles[i].y - particles[j].y;
        const dist = Math.sqrt(dx * dx + dy * dy);

        if (dist < 120) {
          ctx.strokeStyle = `rgba(90,50,15,${1 - dist / 120})`;
          ctx.lineWidth = 0.7;
          ctx.beginPath();
          ctx.moveTo(particles[i].x, particles[i].y);
          ctx.lineTo(particles[j].x, particles[j].y);
          ctx.stroke();
        }
      }
    }
  };

  let animationId;
  const animate = () => {
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    particles.forEach(p => {
      p.move();
      p.draw();
    });

    connect();
    animationId = requestAnimationFrame(animate);
  };

  animate();

  return () => {
    cancelAnimationFrame(animationId);
    window.removeEventListener("resize", resize);
    window.removeEventListener("resize", resizeBg);
  };
}, []);

  return (
    <div className="min-h-screen text-[#3A2A1A] bg-[#FAF6EF] relative">
      {/* BACKGROUND PARTICLE CANVAS */}
    <canvas
      id="bg-particle-canvas"
      tyle={{ zIndex: -50 }}
      className="fixed inset-0  pointer-events-none opacity-60"
    />
{/*<AutoCinematicScroll enabled={true} />*/}

      {/* ================= HERO SECTION ================= */}
      <section className="paper-bg relative overflow-hidden px-8 py-14 flex flex-col lg:flex-row items-center max-w-7xl mx-auto rounded-b-[40px]">
{/* 🔥 PARTICLE CANVAS BACKGROUND */}
  <canvas
    id="particle-canvas"
    className="absolute inset-0 z-0 pointer-events-none"
  />

<div className="paper-dust-layer" />
<div className="ring-wave" />
{/* BORDER ORNAMENTS */}
<div className="border-swirl swirl-left" />
<div className="border-swirl swirl-right" />

  {/* ORNAMENTAL SWIRL (LEFT) */}
  <motion.img
    src={swirl}
    alt=""
    className="absolute top-24 left-10 w-72 z-10 opacity-20 pointer-events-none"
    animate={{ y: [0, -12, 0] }}
    transition={{ duration: 14, repeat: Infinity, ease: "easeInOut" }}
  />

  {/* LEFT CONTENT */}
  <motion.div
    initial={{ opacity: 0, x: -60 }}
    animate={{ opacity: 1, x: 0 }}
    transition={{ duration: 0.8 }}
    className="relative z-20 lg:w-1/2"
  >
    <h1 className="text-5xl md:text-6xl font-bold leading-tight mb-6">
      Journey from Desk <br />
      to <span className="text-[#7A4A28]">Mastery</span>
    </h1>

    <p className="text-lg text-[#5C4632] max-w-xl mb-8">
      Build knowledge, test your skills, analyze performance,
      and grow step-by-step into a true master.
    </p>

    <div className="flex gap-4">
      <Link
        to="/test/practice/69881c424cf5a2ddb6f093ce"
        className="bg-[#7A4A28] text-white px-8 py-3 rounded-lg font-medium shadow-md hover:bg-[#5C4632] transition"
      >
        Start a Test
      </Link>

      <Link
        to="/public-tests"
        className="border-2 border-[#7A4A28] text-[#7A4A28] px-8 py-3 rounded-lg font-medium hover:bg-[#7A4A28] hover:text-white transition"
      >
        Explore Tests
      </Link>
    </div>
  </motion.div>

  {/* RIGHT CHARACTER SECTION */}
  <motion.div
    initial={{ opacity: 0, scale: 0.9 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ duration: 0.9 }}
    className="relative z-30 lg:w-1/2 mt-16 lg:mt-0 flex justify-center lg:-translate-x-6"
  >
    <div className="relative w-[460px] h-[460px] flex items-center justify-center">

      {/* SOFT GLOW */}
      <motion.div
        className="absolute inset-0 rounded-full bg-[#FAF6EF]/30 blur-3xl"
        animate={{ scale: [1, 1.06, 1] }}
        transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
      />

      {/* ROTATING RING */}
      <motion.div
        className="absolute top-[48px] bottom-[48px] right-0
             w-[364px] inset-[74px] rounded-full
             border-[3px] border-[#2F6F6A]/45
             shadow-[0_0_40px_rgba(47,111,106,0.25)]
             before:content-[''] before:absolute
             before:inset-[18px] before:rounded-full
             before:border before:border-dashed
             before:border-[#2F6F6A]/30
             translate-x-[32px] z-0"
        animate={{ rotate: 360 }}
        transition={{ duration: 40, repeat: Infinity, ease: "linear" }}
      />

      {/* MENTOR IMAGE */}
      <img
        src={mentorImg}
        alt="Mentor"
        className="relative z-10 max-h-[580px] -translate-x-8"
      />
    </div>
  </motion.div>

</section>


      {/* ================= CHOOSE YOUR TEST SECTION ================= */}
<StorySection>
<section className="relative px-8 py-24 bg-[#FAF6EF]">
  <div className="max-w-7xl mx-auto">

    {/* HEADING */}
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8 }}
      className="mb-16"
    >
      <h2 className="text-4xl font-bold text-[#3A2A1A] mb-3">
        Choose Your Test
      </h2>
      <p className="text-[#7A4A28] text-lg">
        Select a test type to begin your learning session
      </p>
    </motion.div>

    <div className="grid grid-cols-1 md:grid-cols-3 gap-10">

      {tests.map((test,i)=>(
        <motion.div
          key={i}
          whileHover={{ y:-8, scale:1.02 }}
          transition={{ type:"spring", stiffness:200 }}
          className="relative rounded-2xl bg-[#F4EBDD] border border-[#E6D8C3] shadow-md p-8"
        >

          <h3 className="text-2xl font-semibold mb-3">{test.title}</h3>

          <p className="text-[#5C4632] mb-6">{test.desc}</p>

          <div className="flex gap-3 text-sm text-[#7A4A28] mb-6">
            <span>{test.qs} Qs</span>
            <span>{test.time}</span>
            <span>{test.level}</span>
          </div>

          <Link
  to={
    test._id === "create"
      ? "/createtest"
      : `/test/practice/${test._id}`
  }
  className={`inline-flex items-center gap-2 ${test.color} text-white px-6 py-3 rounded-lg font-medium`}
>
  Start Test →
</Link>


        </motion.div>
      ))}

    </div>

  </div>
</section>
</StorySection>


{/* ================= LEARNING ANALYTICS SECTION ================= */}
<LearningAnalytics />


{/* ================= PERFORMANCE METRICS SECTION ================= */}
<section className="relative px-8 py-28 bg-[#FAF6EF]
 overflow-hidden">
  <div className="max-w-7xl mx-auto relative z-10">

    {/* HEADING */}
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8 }}
      className="mb-14"
    >
      <h2 className="text-4xl font-bold text-[#3A2A1A] mb-2">
        Performance Metrics
      </h2>
      <p className="text-[#7A4A28] text-lg">
        Your achievements and progress statistics
      </p>
    </motion.div>

    {/* METRIC CARDS */}
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-14">

      {/* CARD 1 */}
     <MetricCard
  color="orange"
  value="15"
  label="Current Streak"
  sub="days"
  delay={0}
  icon={<FaFire />}
/>

<MetricCard
  color="blue"
  value="1,247"
  label="Questions Answered"
  sub="total"
  delay={0.1}
  icon={<FaBullseye />}
/>

<MetricCard
  color="yellow"
  value="24"
  label="Achievement Badges"
  sub="earned"
  delay={0.2}
  icon={<FaTrophy />}
/>

<MetricCard
  color="purple"
  value="8,950"
  label="Total XP"
  sub="points"
  delay={0.3}
  icon={<FaBolt />}
/>

    </div>

    {/* RECENT ACHIEVEMENTS */}
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8 }}
      className="bg-[#F4EBDD] rounded-2xl p-8 shadow-xl"
    >
      <h3 className="text-xl font-semibold text-[#3A2A1A] mb-6">
        🏆 Recent Achievements
      </h3>

      <div className="flex flex-wrap gap-4">
        {[
          "7-Day Streak",
          "Quick Learner",
          "Top Scorer",
          "Perfect Score",
        ].map((item) => (
          <span
            key={item}
            className="px-4 py-2 rounded-full border border-[#E6CFA8]
                       text-[#7A4A28] bg-[#FAF6EF] text-sm font-medium"
          >
            {item}
          </span>
        ))}

        <span className="px-4 py-2 rounded-full border border-[#E6CFA8]
                         text-[#7A4A28] bg-[#FAF6EF] text-sm font-medium cursor-pointer">
          View All →
        </span>
      </div>
    </motion.div>
  </div>

  {/* DARK OVERLAY */}
  </section>


{/* ================= YOUR LEARNING PATH SECTION ================= */}
<section className="relative px-8 py-18 bg-[#FAF6EF]
 overflow-hidden">
  <div className="max-w-7xl mx-auto relative z-10">

    {/* HEADING */}
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8 }}
      className="mb-14"
    >
      <h2 className="text-4xl font-bold text-[#3A2A1A] mb-2">
        Your Learning Path
      </h2>
      <p className="text-[#7A4A28] text-lg">
        Follow your personalized curriculum to mastery
      </p>
    </motion.div>

    {/* PATH CARD */}
    <div className="bg-[#F4EBDD] rounded-2xl p-10 shadow-xl space-y-8">

      <LearningItem
        title="Fundamentals of Programming"
        desc="Learn the basics of programming concepts and logic"
        percent={100}
        color="green"
        completed
      />

      <LearningItem
        title="Data Structures & Algorithms"
        desc="Master essential data structures and algorithmic thinking"
        percent={100}
        color="green"
        completed
      />

      <LearningItem
        title="Object-Oriented Programming"
        desc="Understand OOP principles and design patterns"
        percent={65}
        color="blue"
      />

      <LearningItem
        title="Web Development Basics"
        desc="Build interactive websites with HTML, CSS, and JavaScript"
        percent={30}
        color="blue"
      />

      <LearningItem
        title="Advanced JavaScript"
        desc="Deep dive into modern JavaScript features and frameworks"
        locked
      />

      <LearningItem
        title="Full-Stack Development"
        desc="Become a full-stack developer with real-world projects"
        locked
      />

    </div>
  </div>

  {/* DARK OVERLAY */}
  </section>



{/* ================= MEGA FOOTER / FAST LINKS (LIGHT VERSION) ================= */}
<footer className="bg-[#FAF6EF] text-[#3A2A1A] px-8 py-20 border-t border-[#E6D8C3]">
  <div className="max-w-7xl mx-auto">

    {/* TOP NAV LINKS */}
    <div className="flex flex-wrap justify-center gap-10 mb-16 text-sm font-semibold text-[#7A4A28]">
      <span className="cursor-pointer hover:underline">PLUS</span>
      <span className="cursor-pointer hover:underline">SPACES</span>
      <span className="cursor-pointer hover:underline">GET CERTIFIED</span>
      <span className="cursor-pointer hover:underline">FOR TEACHERS</span>
      <span className="cursor-pointer hover:underline">BOOTCAMPS</span>
      <span className="cursor-pointer hover:underline">CONTACT US</span>
    </div>

    {/* LINK COLUMNS */}
    {/* LINK COLUMNS */}
<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">

  <FooterColumn
    title="Practice Tests"
    links={[
      "Python Tests",
      "Machine Learning Tests",
      "DSA Tests",
      "Aptitude Tests",
      "Cybersecurity Tests",
    ]}
  />

  <FooterColumn
    title="Test Playlists"
    links={[
      "Python Basics Series",
      "ML Beginner Series",
      "Interview Preparation",
      "Competitive Coding",
      "Daily Practice",
    ]}
  />

  <FooterColumn
    title="Platform"
    links={[
      "Create Test",
      "Browse Tests",
      "Join Groups",
      "Performance Analytics",
      "Future Roadmap",
    ]}
  />

  <FooterColumn
    title="Company"
    links={[
      "About BharatParikhsa",
      "Contact",
      "Privacy Policy",
      "Terms of Use",
      "GitHub",
    ]}
  />

</div>


    {/* BOTTOM */}
    <div className="border-t border-[#E6D8C3] pt-8 text-center text-sm text-[#5C4632]">

   
      {/* SOCIAL */}
<div className="flex flex-wrap justify-center gap-6 mb-6 font-medium">

  <a
    href="https://instagram.com/YOUR_INSTAGRAM"
    target="_blank"
    rel="noopener noreferrer"
    className="hover:text-[#7A4A28]"
  >
    Instagram
  </a>

  <a
    href="https://linkedin.com/in/vishal-jindher-"
    target="_blank"
    rel="noopener noreferrer"
    className="hover:text-[#7A4A28]"
  >
    LinkedIn
  </a>

  <a
    href="https://github.com/Vishaljindher"
    target="_blank"
    rel="noopener noreferrer"
    className="hover:text-[#7A4A28]"
  >
    GitHub
  </a>

  <a
    href="mailto:yogeshjinder117@gmail.com"
    className="hover:text-[#7A4A28]"
  >
    Email
  </a>

  {/* Internal Support Page */}
  <a
    href="/support"
    className="hover:text-[#7A4A28] underline"
  >
    Support Us
  </a>

</div>

      {/* COPYRIGHT */}
      <p className="leading-relaxed">
        BharatParikhsa is optimized for learning and practice.  
        Tutorials, tests, and analytics help you grow step by step.
        <br />
        © {new Date().getFullYear()} BharatParikhsa. All Rights Reserved.
      </p>

      <p className="mt-3">
        <span className="underline cursor-pointer">Terms of Use</span> ·{" "}
        <span className="underline cursor-pointer">Privacy Policy</span>
      </p>
    </div>

  </div>
</footer>
</div>
  );
}
